const getCoinType = (coinType: string, value: number | string, isDrawer?: boolean) => {
  if(value === null || value === undefined) return value;
  
  switch (coinType) {
    case "BRL":
      return !isDrawer ? `R$ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1.")},00` : `R$ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1.")}`;
    case "EUR":
      return !isDrawer ? `€ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1,")}.00` : `€ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1,")}`;
    default:
      return !isDrawer ? `$ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1,")}.00` : `$ ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/, "$1,")}`;
  };
}

export default getCoinType;